import axios from "@/utils/request";

const base_Url = "/bluetoothlight/web/";

// 帮助中心
const helpquestions = function() {
  return axios({
    method: "get",
    url: base_Url + `other/helpquestions`
  });
};
// 问题删除
const Deletequestions = function(params) {
  return axios({
    method: "delete",
    url: base_Url + `other/helpquestions/${params}`
  });
};
// 问题详情
const questionsDetail = function(params) {
  return axios({
    method: "get",
    url: base_Url + `other/helpquestions/${params}`
  });
};
// 职业管理
const jobs = function(params) {
  return axios({
    method: "get",
    url: base_Url + `other/jobs`,
    params
  });
};
// 删除职业
const Deletejobs = function(params) {
  return axios({
    method: "delete",
    url: base_Url + `other/jobs/${params}`
  });
};
// 修改职业
const updatejobs = function(data) {
  return axios({
    method: "post",
    url: base_Url + `other/jobs/${data.jobId}`,
    data
  });
};
// 官方视频教程列表
const tutorials = function() {
  return axios({
    method: "get",
    url: base_Url + `other/tutorials`
  });
};

export {
  helpquestions,
  jobs,
  Deletejobs,
  updatejobs,
  Deletequestions,
  questionsDetail,
  tutorials
};
